export const journeyFlowItems = {
  myPointOfView: {
    "title": "journeyItems.myPointOfView.title",
    "icon": "eyes_looking",
    "steps": [
      {
        "stepItems": [
          {
            "type": "Intro",
            "mandatory": false,
            "icon": "eyes_looking",
            "title": "journeyItems.myPointOfView.title",
            "description": "journeyItems.myPointOfView.description",
            "state": "whatHappened",
            "side": "mySide"
          }
        ]
      },
      {
        "title": "unnamedMirror",
        "stepItems": [    
          {
            "type": "HappenedCard",
            "mandatory": true,
            "title": "mirroring.titleSituation",
            "label": "mirroring.titleSituation",
            "state": "situationName",
            "cardWrapType": "situationName",
          },
          {
            "type": "TextArea",
            "mandatory": false,
            "label": "mirroring.inYourWords",
            "state": "myTriggerSummary",
            "rows": "4",
            "id": "myTriggerSummary",
            "name": "myTriggerSummary"
          }
        ]
      },
      {
        "title": "unnamedMirror",
        "stepItems": [
          {
            "type": "TextArea",
            "mandatory": false,
            "label": "mirroring.whereDidThatHappen",
            "state": "whereDidThatHappen",
            "rows": "3",
            "id": "whereDidThatHappen",
            "name": "whereDidThatHappen"
          },
          {
            "type": "TextArea",
            "mandatory": false,
            "label": "mirroring.whoWasThereWithYou",
            "state": "whoWasThereWithYou",
            "rows": "3",
            "id": "whoWasThereWithYou",
            "name": "whoWasThereWithYou"
          }
        ]
      },
      {
        "title": "unnamedMirror",
        "stepItems": [
          {
            "type": "FeelsCard",
            "mandatory": true,
            "title": "mirroring.feelTowardsPartner",
            "label": "mirroring.feelTowardsPartner",
            "state": "whatYouNeed",
            "cardWrapType": "feelTowardsSituation",
          },
          {
            "type": "TextArea",
            "mandatory": false,
            "label": "mirroring.inYourWords",
            "rows": "4",
            "state": "whatHappened",
            "id": "whatHappened",
            "name": "whatHappened"
          }
        ]
      },
      
      {
        "title": "mirroring.titleNeeds",
        "stepItems": [
          {
            "type": "NeedCard",
            "mandatory": true,
            "title": "mirroring.whatYouNeed",
            "label": "mirroring.whatYouNeed",
            "state": "whatYouNeed2",
            "cardWrapType": "whatYouNeed",
          },
          {
            "type": "TextArea",
            "mandatory": false,
            "label": "mirroring.inYourWords",
            "state": "whyYouNeed",
            "rows": "4",
            "id": "whyYouNeed",
            "name": "whyYouNeed"
          }
        ]
      }
    ]
  },
  assumePointOfView: {
    "title": "journeyItems.assumePointOfView.title",
    "icon": "shoe",
    "steps": [
      {
        "stepItems": [
          {
            "type": "Intro",
            "mandatory": false,
            "icon": "shoe",
            "title": "journeyItems.assumePointOfView.title",
            "description": "journeyItems.assumePointOfView.description",
            "state": "whatHappened",
            "side": "mySide"
          }
        ]
      },
      {
        "title": "assumePointOfView.assumeHappened-title",
        "stepItems": [
          {
            "type": "HappenedCard",
            "mandatory": true,
            "label": "mirroring.assumeWhatHappened",
            "state": "assumeHappened",
            "cardWrapType": "assumeHappened"
          },
          {
            "type": "TextArea",
            "mandatory": false,
            "label": "mirroring.inYourWords",
            "state": "assumePartnerTriggerSummary",
            "rows": "4",
            "id": "assumePartnerTriggerSummary",
            "name": "assumePartnerTriggerSummary"
          }
        ]
      },
      {
        "title": "assumePointOfView.assumeFeel-title",
        "stepItems": [
          {
            "type": "FeelsCard",
            "mandatory": true,
            "label": "mirroring.assumeFeelTowardsSituation",
            "title": "mirroring.assumeFeelTowardsSituation",
            "state": "assumeFeelTowardsSituation",
            "cardWrapType": "assumeFeelTowardsSituation"
          },
          {
            "type": "TextArea",
            "mandatory": false,
            "label": "mirroring.inYourWords",
            "state": "mirroring.assumeWhyFeelTowardsSituation",
            "rows": "4",
            "id": "assumeWhyFeelTowardsSituation",
            "name": "assumeWhyFeelTowardsSituation"
          }
        ]
      },
      {
        "title": "assumePointOfView.assumeNeed-title",
        "stepItems": [
          {
            "type": "NeedCard",
            "mandatory": true,
            "title": "mirroring.assumeWhatPartnerNeed",
            "label": "mirroring.assumeWhatPartnerNeed",
            "state": "assumeWhatPartnerNeed",
            "cardWrapType": "assumeWhatPartnerNeed"
          },
          {
            "type": "TextArea",
            "mandatory": false,
            "label": "mirroring.inYourWords",
            "state": "assumeWhyPartnerNeed",
            "rows": "4",
            "id": "assumeWhyPartnerNeed",
            "name": "assumeWhyPartnerNeed"
          }
        ]
      }
    ]
  },
  makePlan: {
    "title": "journeyItems.makePlan.title",
    "icon": "plan",
    "steps": [
      {
        "stepItems": [
          {
            "type": "Intro",
            "mandatory": false,
            "icon": "plan",
            "title": "journeyItems.makePlan.subtitle",
            "description": "journeyItems.makePlan.description",
            "state": "AISummary",
            "side": "mySide"
          }
        ]
      },
      {
        "stepItems": [
          {
            "type": "recap",
            "mandatory": true,
            "state": "recapDone"
          }
        ]
      },
      {
        "stepItems": [
          {
            "type": "suggestedIdeas",
            "mandatory": false,
            "state": "AISummary",
          }
        ]
      },
      {
        "stepItems": [
          {
            "type": "makePlan",
            "mandatory": false,
            "state": "AISummary"
          }
        ]
      }
    ]
  },
  DummyDynamicStep: {
    "title": "Dummy dynamically created",
    "icon": "dummy",
    "steps": [
      {
        "stepItems": [
          {
            "type": "FeelsCard",
            "mandatory": false,
            "icon": "dummy",
            "title": "dummy step",
            "description": "this is the description",
            "state": "dummyStep",
            "side": "mySide"
          }
        ]
      }
    ]
  }
}

export const buildJourneyFromStepIds = (journeyStepIds) => {
  const legacyAlias = { AIStep: 'makePlan' };
  return journeyStepIds
    .map((journeyItemStepId) => legacyAlias[journeyItemStepId] || journeyItemStepId)
    .map((journeyItemStepId) => journeyFlowItems[journeyItemStepId])
    .filter(Boolean)
}